<script>
    import Button from "./Button.svelte";
    import Label from "./Label.svelte";
    import { HStack } from "../layout";

    export let id;
    export let value;
    export let current;
    export let label;
    export let icon = null;
    export let margin = true;
    export let values = [];

    let opened = false;
    let selected_count = 0;

    const onClick = () => {
        opened = !opened;
    };

    const onPickerSelect = (v) => {
        selected_count = value.reduce((a, c) => {
            if (c) a += 1;
            return a;
        }, 0);
    };

    function clickOutside(node, { enabled: initialEnabled, cb }) {
        const handleOutsideClick = ({ target }) => {
            if (!node.contains(target)) {
                cb();
            }
        };

        function update({ enabled }) {
            if (enabled) {
                window.addEventListener("click", handleOutsideClick);
            } else {
                window.removeEventListener("click", handleOutsideClick);
            }
        }

        update({ enabled: initialEnabled });
        return {
            update,
            destroy() {
                window.removeEventListener("click", handleOutsideClick);
            },
        };
    }
</script>

<article
    class="input-checkbox check-left"
    class:in={current === id}
    class:margin
    use:clickOutside={{ enabled: opened, cb: () => (opened = false) }}>
    <Button action={onClick}>
        <HStack grow alignment="center">
            <Label text={label} {icon} />
            {#if selected_count > 0}
                <span class="counter">{selected_count}</span>
            {/if}
            <Label icon="chevron-down" />
        </HStack>
    </Button>

    <div class="picker" class:opened>
        <div class="labels">
            {#each values as v, i}
                <label class="container" class:checked={value[i]}>
                    <input
                        type="checkbox"
                        name={id}
                        value={v.id || v.value}
                        bind:checked={value[i]}
                        on:change={() => onPickerSelect(v)} />
                    <span class="check" />
                    <span>{v.name || v.label}</span>
                </label>
            {/each}
        </div>
    </div>
</article>

<style>
    article {
        position: relative;
        height: 100%;
        border-radius: 3px;
        display: flex;
        justify-items: stretch;
    }
    article:hover {
        background-color: rgb(235, 236, 240);
    }
    .counter {
        background-color: rgb(0, 82, 204);
        color: rgb(255, 255, 255);
        border-radius: 2em;
        display: inline-block;
        font-size: 12px;
        font-weight: normal;
        line-height: 1;
        min-width: 1px;
        padding: 0.166667em 0.5em;
        text-align: center;
    }
    .container {
        display: block;
        position: relative;
        background-color: white;
        padding-left: 1em;
        padding-right: 1em;
        font-size: 14px;
        line-height: 2em;
        cursor: pointer;
        user-select: none;
    }
    .container:hover {
        background-color: rgb(235, 236, 240);
    }

    .input-checkbox [type="checkbox"] {
        cursor: pointer;
        height: 17px;
        left: 0;
        margin: 0 !important;
        opacity: 0;
        position: absolute;
        top: 2px;
        width: 17px;
    }

    .input-checkbox [type="checkbox"]:not(:checked) + .check::before {
        background-color: rgb(235, 236, 240);
        border: 1px solid #ccc;
    }
    .input-checkbox [type="checkbox"]:checked + .check::before {
        background: var(--primary-light-color);
        border: 1px solid var(--primary-light-color);
    }

    .input-checkbox .check::before {
        border-radius: 2px;
        content: "";
        height: 12px;
        left: 0;
        position: absolute;
        top: 0;
        width: 12px;
    }

    .input-checkbox .check::after {
        color: rgb(235, 236, 240);
        content: "\2713";
        font-size: 13px;
        height: 12px;
        width: 12px;
        line-height: 16px;
        position: absolute;
        top: 0;
        left: 0;
    }

    .input-checkbox label {
        line-height: 1.3;
        margin-bottom: 0;
        font-size: 14px;
    }

    .input-checkbox.check-left label {
        padding-left: 25px;
    }
    .input-checkbox .check {
        cursor: pointer;
        display: inline-block;
        height: 12px;
        width: 12px;
        position: absolute;
        top: 5px;
        left: 5px;
        pointer-events: none;
        text-align: center;
        background-color: rgb(235, 236, 240);
    }

    .picker {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 50px;
        visibility: hidden;
        background-color: white;
        border: 1px solid var(--secondary-light-color);
        border-radius: 5px;
        box-shadow: rgb(9 30 66 / 25%) 0px 4px 8px -2px, rgb(9 30 66 / 31%) 0px 0px 1px;
        box-sizing: border-box;
        overflow: auto;
        padding: 4px 0px;
        max-height: 90vh;
    }

    .picker.opened {
        visibility: visible;
        z-index: 1;
    }
    .picker label {
        padding: 4px 12px 4px 16px;
        display: flex;
        align-items: center;
    }

    .picker > div {
        max-height: 500px;
        overflow-y: auto;
        padding-bottom: 8px;
        padding-top: 8px;
        position: relative;
        box-sizing: border-box;
        max-width: 288px;
    }
</style>
